import React from "react";
import { sendClientSideSplitTrackEvent } from "@leafly-com/split-next";
import pluralize from "pluralize";
import { useSelector } from "react-redux";

import { useEventTracker } from "hooks/useEventTracker";
import { getCurrentDispensary } from "redux/selectors/dispensary";
import { getTotalDispensaryReviewsCount } from "redux/selectors/reviews";
import { getSplitKey } from "utils/split/getSplitKey";
import { Action, Category, Label } from "utils/trackEvent";

import StarRating from "components/botanic/StarRating";

import WriteDispensaryReviewButton from "../Reviews/components/ReviewContainer/WriteDispensaryReviewButton";
import RatingCircle from "./RatingCircle";

const ReviewsHeader: React.FC = () => {
  const { publishEvent } = useEventTracker();
  const totalReviews = useSelector(getTotalDispensaryReviewsCount);

  const {
    name,
    slug,
    atmosphereRating,
    qualityRating,
    serviceRating,
    rating,
    id,
    retailType,
  } = useSelector(getCurrentDispensary);

  const publishWriteReviewEvent = () => {
    publishEvent({
      action: Action.click,
      category: Category.dispensaryMenu,
      dispensaryId: id,
      label: Label.writeReview,
    });
    sendClientSideSplitTrackEvent("NL-420_writeReview_click", getSplitKey());
  };

  return (
    <div>
      <div className="section__header">
        <h3 className="heading--m">
          {`${totalReviews || 0} ${pluralize(
            "Review",
            totalReviews
          )} of ${name}`}
        </h3>
      </div>
      <StarRating
        rating={rating || 0}
        starWidth={18}
        className="mb-xl text-sm"
        ratingCount={totalReviews || 0}
      />
      <div className="flex mb-xl">
        <RatingCircle
          rating={qualityRating}
          label="Quality"
          className="mr-xxl"
        />
        <RatingCircle
          rating={serviceRating}
          label="Service"
          className="mr-xxl"
        />
        <RatingCircle rating={atmosphereRating} label="Atmosphere" />
      </div>
      <div data-testid="write-review">
        <WriteDispensaryReviewButton
          slug={slug}
          onClick={publishWriteReviewEvent}
          retailType={retailType}
        />
      </div>
    </div>
  );
};

export default ReviewsHeader;
